<dialog class="agenda" #dialogo aria-labelledby="reagendamento-titulo" (close)="aoFechar()">
  <!-- Fechado, o modal não tem conteúdo: nada de calendário nem de região `status` fora de uso na página. -->
  @if (agendamento(); as item) {
    <div class="agenda-topo">
      <div>
        <h2 class="agenda-titulo" id="reagendamento-titulo">Reagendar atendimento</h2>
        <p class="agenda-subtitulo">
          Escolha o novo dia e depois um dos horários disponíveis. O serviço e o local não mudam.
        </p>
      </div>

      <button type="button" class="agenda-fechar" aria-label="Fechar" (click)="fechar()">
        <i-lucide name="x" size="20" aria-hidden="true"></i-lucide>
      </button>
    </div>

    <dl class="reagendamento-atual">
      <div>
        <dt>Serviço</dt>
        <dd>{{ item.desNomeServicoSsv }}</dd>
      </div>
      <div>
        <dt>Horário atual</dt>
        <dd>{{ horarioAtual() }}</dd>
      </div>
      @if (item.desLocalAtendimentoSsv) {
        <div class="reagendamento-atual-largo">
          <dt>Local de atendimento</dt>
          <dd>{{ item.desLocalAtendimentoSsv }}</dd>
        </div>
      }
    </dl>

    @if (postoIndisponivel()) {
      <!-- No lugar do calendário: a agenda deste posto não existe mais, e o cidadão não troca de posto. -->
      <div class="reagendamento-indisponivel" role="alert">
        <i-lucide name="map-pin-off" size="18" aria-hidden="true"></i-lucide>
        <p>
          Este posto não está mais recebendo agendamentos. Cancele este agendamento e agende em outro posto, ou
          aguarde o contato do órgão.
        </p>
      </div>
    } @else {
      <div class="agenda-corpo">
        <section class="agenda-bloco" aria-labelledby="reagendamento-calendario-titulo">
          <h3 class="agenda-bloco-titulo" id="reagendamento-calendario-titulo">
            <i-lucide name="calendar" size="18" aria-hidden="true"></i-lucide>
            Selecione a nova data
          </h3>

          <div class="agenda-navegacao">
            <button type="button" class="agenda-seta" aria-label="Mês anterior" [disabled]="!podeVoltarMes()" (click)="mesAnterior()">
              <i-lucide name="chevron-left" size="18" aria-hidden="true"></i-lucide>
            </button>

            <span class="agenda-mes" aria-live="polite">{{ rotuloMes() }}</span>

            <button type="button" class="agenda-seta" aria-label="Próximo mês" [disabled]="!podeAvancarMes()" (click)="proximoMes()">
              <i-lucide name="chevron-right" size="18" aria-hidden="true"></i-lucide>
            </button>
          </div>

          <div class="agenda-semana" aria-hidden="true">
            @for (dia of diasSemana; track $index) {
              <span>{{ dia }}</span>
            }
          </div>

          @if (carregando()) {
            <p class="agenda-estado" role="status" aria-live="polite">
              <i-lucide name="loader-circle" size="16" aria-hidden="true"></i-lucide>
              Carregando os horários disponíveis...
            </p>
          } @else if (falhou()) {
            <div class="agenda-estado agenda-estado-falha" role="alert">
              <i-lucide name="circle-alert" size="16" aria-hidden="true"></i-lucide>
              <span>Não foi possível carregar a agenda.</span>
              <button type="button" class="agenda-estado-botao" (click)="recarregar()">Tentar novamente</button>
            </div>
          } @else if (mesSemHorarios()) {
            <p class="agenda-estado" role="status">
              <i-lucide name="calendar-x" size="16" aria-hidden="true"></i-lucide>
              Não há horários disponíveis neste mês.
            </p>
          }

          <div class="agenda-grade">
            @for (dia of diasDoMes(); track dia.iso) {
              @if (dia.dia === null) {
                <span class="agenda-dia-vazio"></span>
              } @else {
                <button
                  type="button"
                  class="agenda-dia"
                  [class.agenda-dia-hoje]="dia.hoje"
                  [class.agenda-dia-selecionado]="dia.iso === dataSelecionada()"
                  [disabled]="dia.indisponivel"
                  [attr.aria-pressed]="dia.iso === dataSelecionada()"
                  (click)="selecionarDia(dia)"
                >
                  {{ dia.dia }}
                </button>
              }
            }
          </div>
        </section>

        <section class="agenda-bloco" aria-labelledby="reagendamento-horarios-titulo">
          <h3 class="agenda-bloco-titulo" id="reagendamento-horarios-titulo">
            <i-lucide name="clock" size="18" aria-hidden="true"></i-lucide>
            Selecione o novo horário
          </h3>

          @if (dataSelecionada()) {
            <div class="agenda-horarios">
              @for (horario of horariosDoDia(); track horario) {
                <button
                  type="button"
                  class="agenda-horario"
                  [class.agenda-horario-selecionado]="horario === horarioSelecionado()"
                  [attr.aria-pressed]="horario === horarioSelecionado()"
                  (click)="selecionarHorario(horario)"
                >
                  {{ horario }}
                </button>
              }
            </div>
          } @else {
            <p class="agenda-vazio">
              <i-lucide name="calendar-search" size="18" aria-hidden="true"></i-lucide>
              Escolha uma data no calendário para ver os horários disponíveis.
            </p>
          }
        </section>
      </div>
    }

    @if (erro(); as falha) {
      <div class="reagendamento-erro" role="alert">
        <i-lucide name="circle-alert" size="16" aria-hidden="true"></i-lucide>
        <div>
          @if (falha.detalhes.length) {
            @for (detalhe of falha.detalhes; track $index) {
              <p>{{ detalhe }}</p>
            }
          } @else {
            <p>{{ falha.mensagem }}</p>
          }
        </div>
      </div>
    }

    <div class="agenda-rodape">
      @if (mesmoHorario()) {
        <p class="agenda-resumo agenda-resumo-pendente" role="status">
          Este é o horário atual do agendamento. Escolha outro.
        </p>
      } @else if (podeConfirmar() || enviando()) {
        <p class="agenda-resumo" role="status">
          <i-lucide name="circle-check" size="16" aria-hidden="true"></i-lucide>
          Novo horário: {{ dataFormatada() }} às {{ horarioSelecionado() }}
        </p>
      } @else if (!postoIndisponivel()) {
        <p class="agenda-resumo agenda-resumo-pendente" role="status">
          Selecione a nova data e o novo horário para confirmar.
        </p>
      }

      <div class="agenda-acoes">
        <button type="button" class="agenda-botao" (click)="fechar()">Fechar</button>

        <button
          type="button"
          class="agenda-botao agenda-botao-primario"
          [disabled]="!podeConfirmar()"
          (click)="confirmar()"
        >
          <i-lucide name="check" size="16" aria-hidden="true"></i-lucide>
          {{ enviando() ? 'Confirmando...' : 'Confirmar novo horário' }}
        </button>
      </div>
    </div>
  }
</dialog>
